import React from 'react';
import { Calendar, Clock, MapPin, Users, FileText } from 'lucide-react';

const EventDetails = ({ booking, formatDate, formatTime }) => {
  return (
    <div className="bg-white border rounded-lg p-2 sm:p-3">
      <h3 className="text-sm sm:text-base font-bold text-black mb-2 sm:mb-3">Event Details</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
        <div className="flex items-start gap-2">
          <Calendar className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs text-gray-600 font-medium mb-0.5">Event Date</p>
            <p className="text-sm text-black font-medium">{formatDate(booking.event_date)}</p>
          </div>
        </div>
        <div className="flex items-start gap-2">
          <Clock className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs text-gray-600 font-medium mb-0.5">Time</p>
            <p className="text-sm text-black font-medium">
              {formatTime(booking.start_time)} - {formatTime(booking.end_time)}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-2">
          <Clock className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs text-gray-600 font-medium mb-0.5">Duration</p>
            <p className="text-sm text-black font-medium">{booking.duration_hours} hours</p>
          </div>
        </div>
        {booking.guest_count && (
          <div className="flex items-start gap-2">
            <Users className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-xs text-gray-600 font-medium mb-0.5">Guest Count</p>
              <p className="text-sm text-black font-medium">{booking.guest_count} guests</p>
            </div>
          </div>
        )}
        {booking.event_location && (
          <div className="flex items-start gap-2 sm:col-span-2">
            <MapPin className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs text-gray-600 font-medium mb-0.5">Location</p>
              <p className="text-xs sm:text-sm text-black font-medium break-words">{booking.event_location}</p>
              {booking.event_address && booking.event_address !== booking.event_location && (
                <p className="text-xs text-gray-600 mt-0.5 break-words">{booking.event_address}</p>
              )}
            </div>
          </div>
        )}
        {booking.event_type && (
          <div className="flex items-start gap-2 sm:col-span-2">
            <FileText className="w-4 h-4 text-black mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-xs text-gray-600 font-medium mb-0.5">Event Type</p>
              <p className="text-sm text-black font-medium">{booking.event_type}</p>
            </div>
          </div>
        )}
      </div>
      {booking.special_requirements && (
        <div className="mt-2 sm:mt-3 pt-2 sm:pt-3 border-t-2 border-gray-300">
          <p className="text-xs text-gray-600 font-medium mb-1">Special Requirements</p>
          <p className="text-sm text-black">{booking.special_requirements}</p>
        </div>
      )}
    </div>
  );
};

export default EventDetails;

